<template>
  <!-- 顶部标题栏容器 -->
  <div class="top-title-bar">
    <h1 class="project-title">{{ currentTitle }}</h1>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';

// 获取当前路由实例
const route = useRoute();
// 绑定当前页面标题，默认值为项目名称
const currentTitle = ref(route.meta.title || '黄金梨优享汇');

// 监听路由变化，动态更新标题
watch(
    () => route.meta.title,
    (newTitle) => {
      currentTitle.value = newTitle || '黄金梨优享汇';
    }
);
</script>

<style scoped>
/* 标题栏样式，可按需调整 */
.top-title-bar {
  width: 100vw;
  background-color: #EEDC82;
  text-align: center;
  /*border-bottom: 1px solid #eee;*/
}

.project-title {
  font-size: 28px;
  font-weight: 700;
  color: #333333;
  margin: 0;
}
</style>